"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMON_PROPS = void 0;
var COMMON_PROPS = ['crossOrigin', 'decoding', 'draggable', 'loading', 'referrerPolicy', 'sizes', 'srcSet', 'useMap', 'alt'];
exports.COMMON_PROPS = COMMON_PROPS;